export default __webpack_public_path__ + "static/media/ARIALBD.2a15db11.woff";